import React from 'react'

const ServicesReportByMonthContent = ({ title, packages, sign }) => {
  return (
    <div>
      {title && <h3>{title}</h3>}
      {packages.length &&
        packages.map((items, index) => {
          return (
            <p key={`${title}_${sign}_${index}`}>
              {items.packages.map((pkg, i) => {
                return (
                  <span key={`${title}_${sign}_${index}_${i}`}>
                    <b>{items.acronym}</b>
                    {` ${sign} ${pkg.package}${
                      pkg.comment ? ' - ' + pkg.comment : ''
                    }`}
                    <br />
                  </span>
                )
              })}
            </p>
          )
        })}
    </div>
  )
}

export { ServicesReportByMonthContent }
